import { PricingActionTypes } from './action-types';
export const updatePromotionsResponse = promotionsResponse => dispatch => {
  dispatch({
    type: PricingActionTypes.UpdatePromotionsResponse,
    promotionsResponse
  });
};
export const updateRequiredOnboarding = requiredOnboarding => dispatch => {
  dispatch({
    type: PricingActionTypes.UpdateRequiredOnboarding,
    requiredOnboarding
  });
};
export const updateDtbId = dtbId => dispatch => {
  dispatch({
    type: PricingActionTypes.UpdateDtbId,
    dtbId
  });
};
export const updateProductResponse = productResponse => dispatch => {
  dispatch({
    type: PricingActionTypes.UpdateProductsResponse,
    productResponse
  });
};
export const updateCurrencyCode = currencyCode => dispatch => {
  dispatch({
    type: PricingActionTypes.UpdateCurrencyCode,
    currencyCode
  });
};
export const fetchProductsForPricing = () => dispatch => {
  dispatch({
    type: PricingActionTypes.FetchProducts
  });
};
export const fetchPromotionsForPricing = () => dispatch => {
  dispatch({
    type: PricingActionTypes.FetchPromotions
  });
};